export class Service {
  id: number;
  name: string;
  description: string;
  label?: string;
  parentId: number;
  constructor(data: any) {
    Object.assign(this, data);
  }
}
